export default __webpack_public_path__ + "locales/sl/VersionHistory.json?hash=c711208b4325bc8209f7ccd29f5b7a42";